// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimFilterPanel-cls1_SOF","cls2":"ClaimFilterPanel-cls2_jgV ClaimFilterPanel-cls1_SOF"};